import React from "react";
import styled from "@emotion/styled";
import HeaderLink, { HeaderLinkProps } from "./HeaderLink";
import { getRelativePath } from "@src/utils/routes";
import { logEvent } from "@src/utils/logClient";
import window from "global/window";
import { mediaQueries } from "@src/styles/theme";

const ListItem = styled("li")`
  padding: 10px 15px;
  list-style: none;
  margin-top: 0;
  ${mediaQueries[2]} {
    padding: 0;
  }
`;

const NavListItem = ({ path, eventName, ...linkProps }: { path: string; eventName: string } & HeaderLinkProps) => {
  const onClick = () => {
    if (!window || !window.location) return;

    return logEvent({
      eventValue: window.location.href,
      eventName,
    });
  };

  return (
    <ListItem>
      <HeaderLink to={getRelativePath(path)} onClick={onClick} {...linkProps} />
    </ListItem>
  );
};

export default NavListItem;
